module.exports = __webpack_public_path__ + "static/media/listnews-icon.ebdf6af2.svg";